import {
    onJSBridgeConnected,
    onAdShow,
    onAdShowTemp,
    fetchInitData,
    readyToShowAD,
    failureToShowAD,
    broadcast,
    onBroadcast,
    closeAd,
    bannerFetchInitData,
    bannerReadyToShowAD
} from "../api";
import VConsole from 'vconsole'
import Unit from "./Unit";
import Webview from "./component/native/visible/Webview";
import {fireEvent} from "../common/util";
import { fullScreenShow } from "../api/nativeComponentAPI";

let vConsole
function getVConsoleInstance(){
    vConsole = vConsole || new VConsole()
    return vConsole
}

let nativeComponentMap = {}
document.addEventListener('nativeComponentCreated', function(event){
    const { id, instance } = event.param
    nativeComponentMap[id] = instance
})



const App =  {
    unit:{},

    enableDebugMode() {
        getVConsoleInstance()
    },

    onJSBridgeConnected,
    readyToShowAD,
    failureToShowAD,
    broadcast,
    onBroadcast,
    bannerReadyToShowAD,
    closeAd(){
        closeAd(this.unit.id || this.initData && this.initData.unit_id, App.rootViewId)
    },
    onAdShow(cb){
        console.log('sbd 注册 onAdShow')
        onBroadcast('MTG_AdShow',(event) => {
            console.log('接收到广播 MTG_AdShow')
            const { data } = event
            cb(data)
        })
    },
    //收到父视图发来的消息
    onWebviewPostMessage(cb) {
        onBroadcast('webviewPostMessage', (event)=>{
            console.log('收到postmessage', event, this,this.rootWebview)
            const { data={} } = event
            if(data.id === this.rootWebview.id){
                cb && cb(data.data)
            }
        })
    },
    //收到子视图向父视图发来的送消息
    onEmitMessage(eventName, cb) {
        onBroadcast('webviewEmitMessage', (event)=>{
            // console.log('收到EmitMessage',event,nativeComponentMap,nativeComponentMap[event.data.id],eventName,event.data.eventName)
            const { data={} } = event
            if(nativeComponentMap[data.id] && data.id!==this.rootWebviewId && eventName===data.eventName){
                console.warn('收到指定的 ==》 EmitMessage', event,nativeComponentMap,nativeComponentMap[data.id],eventName,data.eventName)
                cb && cb(data.data)
            }
        })
    },
    //向父视图发送消息
    emitMessage(eventName, params={}) {
        const _params = {
            id: this.rootWebview.id,
            eventName,
            data: {
                ...params
            }
        }
        return broadcast('webviewEmitMessage', _params)
    },


    fullScreenShow(componentId) {
        console.log('fullScreenShow :: ',componentId)
        return new Promise(resolve => {
            console.log("fullScreenShow---",this.initData)
            if(this.initData.sdkSetting.isRootTemplateWebView){
                let device = this.initData.device
                let width = +device.screen_width
                let height = +device.screen_height
                console.log("fullScreenShow---",width,height,device)
                //{ top:0, height, left:0, width }
                fullScreenShow(componentId, this.rootWebviewId).then(()=>{
                    resolve()
                })
            }else{
                this.emitMessage('MTG_fullScreenShow', {
                    componentId
                })
            }
        })
    },

    loadTemplate({ templateClass, templateLoader, loadCallback, fetchFun }){
        const tplLoader = new templateLoader()

        return tplLoader.loadTemplate(templateClass, (data)=>{
            this.rootViewId = tplLoader.getRootViewId()
            this.rootView = tplLoader.getRootView()
            this.rootWebviewId = tplLoader.getRootWebviewId()
            this.rootWebview = tplLoader.getRootWebview()
            this.unit = tplLoader.getUnit()
            this.initData = tplLoader.getInitData()
            loadCallback(data)
        }, fetchFun)
    }
}

onAdShow((data) => {
    console.log('--onAdShow ============>', data)
    App.broadcast('MTG_AdShow',data)
})

App.onEmitMessage('MTG_fullScreenShow', (event)=>{
    console.log('MTG_fullScreenShow ============>', event)
    /*setTimeout(()=>{
        App.fullScreenShow(event.componentId)
    },4e3)*/
    App.fullScreenShow(event.componentId)
})


export default App